import { ShieldCheck } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal, Overline } from "../components/motion";
import { CERTIFICATES, CONTACT } from "../data";

export default function Certifications() {
  return (
    <>
      <PageHeader
        overline="Regulatory Standing"
        lines={["Registered with", "the RBI."]}
        subtitle="Ashutosh's NBFC entities hold Certificates of Registration issued by the Reserve Bank of India under Section 45-IA of the RBI Act, 1934."
      />

      <section className="py-20 md:py-28 bg-bg" data-testid="certifications-grid">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-20">
          <Reveal>
            <div className="flex items-center gap-3"><ShieldCheck className="text-brand-green" size={20} /><Overline>Certificates of Registration</Overline></div>
          </Reveal>
          <div className="mt-10 grid md:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
            {CERTIFICATES.map((c, i) => (
              <Reveal key={c.reg} delay={i * 0.06}>
                <div className="bg-bg p-8 h-full group hover:bg-surface transition-colors duration-500" data-testid={`certificate-${i}`}>
                  <div className="flex items-center justify-between">
                    <div className="overline text-ink/35">RBI CoR · {c.date}</div>
                    <ShieldCheck size={18} className="text-ink/25 group-hover:text-brand-green transition-colors duration-500" />
                  </div>
                  <div className="mt-6 font-heading font-bold text-ink text-lg leading-snug">{c.entity}</div>
                  <div className="mt-4 font-body text-sm text-brand-green tracking-wide">Reg. No. {c.reg}</div>
                  <div className="mt-2 font-body text-xs text-ink/40">{c.note}</div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-14 border border-ink/10 bg-surface p-8 md:p-10 grid md:grid-cols-2 gap-8">
              <div>
                <div className="overline text-ink/35">Legal entity</div>
                <div className="mt-3 font-heading font-bold text-ink text-lg">{CONTACT.legalName}</div>
                <div className="mt-2 font-body text-sm text-ink/50">CIN {CONTACT.cin}</div>
              </div>
              <div>
                <div className="overline text-ink/35">Registered office</div>
                <div className="mt-3 font-body text-sm text-ink/70 leading-relaxed max-w-sm">{CONTACT.address}</div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <p className="mt-6 font-body text-xs text-ink/30 max-w-3xl">NBFC registrations under Section 45-IA of the RBI Act, 1934. Not valid for acceptance of public deposits.</p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
